
import { defineComponent, ref } from 'vue'
import LoginAccount from './login-account.vue'
import LoginPhone from './login-phone.vue'
import localCache from '@/utils/cache'

export default defineComponent({
  components: {
    LoginAccount,
    LoginPhone
  },
  setup() {
    const isKeepPassword = ref(!!localCache.getCache('name') ?? false)

    // 獲取組件類型
    const accountRef = ref<InstanceType<typeof LoginAccount>>()
    const currentTab = ref('account')

    const handleLoginClick = () => {
      if (currentTab.value === 'account') {
        accountRef.value?.loginAction(isKeepPassword.value)
      }
    }

    const keepChange = (value: boolean) => {
      if (!value) {
        localCache.deleteCache('name')
        localCache.deleteCache('password')
      }
    }

    return {
      isKeepPassword,
      handleLoginClick,
      accountRef,
      keepChange,
      currentTab
    }
  }
})
